<script lang="ts">
  export let isOpen: boolean = false;
</script>

<div class="flex items-center h-full px-4 font-bold text-15 text-nxgray-600">
  <span class="mr-3 material-icons text-18"> add_reaction </span>
  React
</div>
